/**
 * After rc7 (the "Update your card" save that got no answer, three times on 2026-10-30): the button that saves a card is pressable
 * only once Stripe's card form says it is ready. Reproduced under local:e2e with a trace: Save card was pressed while Stripe was still
 * adding its own frames to the page, the press never reached the page (a listener on the whole document saw no click), and nothing
 * was saved or said; with a short pause before the press it did not happen in five runs. Which of Stripe's frames took the press is
 * not known. A donor on a slow phone could press as early. `loaderror` (Stripe's form could not load) is said plainly by the caller.
 */

/**
 * Keeps `button` disabled until `paymentElement` fires `ready`; then enables it and marks `root` with `data-anudan-ready`.
 *
 * @param {{on?: Function}} paymentElement Stripe's Payment Element.
 * @param {HTMLButtonElement} button The button that saves.
 * @param {HTMLElement} root Marked `data-anudan-ready` when ready, for the checks.
 * @param {() => void} failed Says the form could not load.
 * @return {void}
 */
export function whenReady( paymentElement, button, root, failed ) {
	const ready = () => {
		button.disabled = false;
		root.dataset.anudanReady = '1';
	};

	button.disabled = true;

	if ( ! paymentElement || 'function' !== typeof paymentElement.on ) {
		ready();

		return;
	}

	paymentElement.on( 'ready', ready );
	paymentElement.on( 'loaderror', failed );
}
